export default __webpack_public_path__ + "static/media/2276.44dbeef7.png";